import React from 'react';
import { Input } from 'antd';
import { Search } from 'lucide-react';

/** Search box above the products table (name, code or category). */
export default function ProductsActions({ onSearch, total }) {
    return (
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <Input
                placeholder="Buscar producto por nombre, código o categoría"
                prefix={<Search className="text-surface-400" />}
                onChange={(event) => onSearch(event.target.value)}
                className="sm:max-w-md"
                allowClear
            />
            {total !== undefined && <span className="text-sm text-surface-500 tabular-nums">{total} productos</span>}
        </div>
    );
}
